// React for Website

import React, { useState } from "react";
import { useParams } from "react-router-dom";
//outsource
import { Row, Col, Form, Modal, Button, message } from "antd";

//components
import VoucherAmount from "./component/voucher_amount";
import VoucherLastName from "./component/voucher_last_name";
import VoucherFirstName from "./component/voucher_first_name";
import VoucherEmail from "./component/voucher_email";
import VoucherMessage from "./component/voucher_message";

//redux
import { useDispatch, useSelector } from "react-redux";
import { detailSelector } from "../../../store/branch/branch.selector";
import { addVoucher } from "../../../store/voucher/voucher.action";

const DialogSendVoucher = ({ open, setOpen, user, vouchers }) => {
  // -------------------------- VAR --------------------------
  const [form] = Form.useForm();
  const params = useParams();
  const id = params.id;
  const voucherPackage = params.packageId;

  // -------------------------- STATE --------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const branch = useSelector(detailSelector);
  const shopId = branch?.shopId || "";
  const senderEmail = branch?.email || null;
  const senderPhone = branch?.phone || null;
  const senderName = branch?.name || null;
  // console.log("email", email);
  // -------------------------- FUNCTION --------------------------
  const onFinish = (values) => {
    if (id !== "" && values && user && branch) {
      const price = values?.amount * 100 || "";
      // const balance = price !== "" ? parseFloat(price) : 0;
      const description = values?.message || "";
      const email = values?.email || "";
      const firstName = values?.firstName || "";
      const lastName = values?.lastName || "";

      const voucher = [
        {
          email,
          firstName,
          lastName,
          price,
          description,
        },
      ];

      const sender = {
        email: senderEmail,
        firstName: senderName,
        lastName: senderName,
        phone: senderPhone,
      };

      const branch = {
        id,
        shopId,
        voucherPackage,
      };
      const note = "";

      // console.log("branch", branch);

      setLoading(true);
      dispatch(
        addVoucher({ vouchers: voucher, sender, branch, note }, (response) => {
          if (response.status === 200) {
            message.success(
              "Sent Gift successfully! Email will be sent to receiver now."
            );
            setLoading(false);
            setOpen(false);
            form.resetFields();
          } else {
            message.error(response.data || "Please try again");
            setLoading(false);
          }
        })
      );
    }
  };

  const onFinishFailed = (errors) => {
    console.log("errors", errors);
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------
  const renderFooter = () => {
    return (
      <Row>
        <Col align="left" span={12}>
          <Button
            loading={loading}
            onClick={() => setOpen(false)}
            type="default"
          >
            Cancel
          </Button>
        </Col>
        <Col align="right" span={12}>
          <Button
            loading={loading}
            form="send-voucher"
            htmlType="submit"
            type="primary"
          >
            Send Gift
          </Button>
        </Col>
      </Row>
    );
  };

  const renderBody = () => {
    return (
      <Row gutter={[20, 20]}>
        <Col lg={12} md={12} sm={24} xs={24}>
          <VoucherAmount form={form} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <VoucherEmail />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <VoucherFirstName />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <VoucherLastName />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <VoucherMessage />
        </Col>
      </Row>
    );
  };
  // -------------------------- MAIN --------------------------
  return (
    <Modal
      title="Gift Voucher"
      visible={open}
      onCancel={() => setOpen(false)}
      footer={renderFooter()}
      width={700}
      centered
    >
      <Form
        id="send-voucher"
        type="basic"
        autoComplete="off"
        layout="vertical"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        {renderBody()}
      </Form>
    </Modal>
  );
};

export default DialogSendVoucher;
